import React, { useEffect } from 'react'
import { addWeldersOne } from '../../../api/welding.api'
import * as actions from '../../../reducers/form';
import SimpleAdd from '../../../components/SimpleAdd'
import { enqueueSnackbar } from '../../../reducers/notifier'
import { useHistory } from 'react-router-dom'
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import validateProps from '../../../functions/validateProps'

const formName = 'WeldersAdd'
const arrProps = [
  {
    bp: { xs: 12 },
    field: 'lastName', label: 'Фамилия', type: 'text',
    validator: [value => value !== ''], errorText: 'Поле обязательно',
  },
  {
    bp: { xs: 12 },
    field: 'firstName', label: 'Имя', type: 'text',
    validator: [value => value !== ''], errorText: 'Поле обязательно',
  },
  {
    bp: { xs: 12 },
    field: 'middleName', label: 'Отчество', type: 'text',
  },
  {
    bp: { xs: 12 },
    field: 'qualification', label: 'Разряд квалификационный', type: 'text',
  },
  {
    bp: { xs: 12 },
    field: 'stamp', label: 'Номер личного клейма', type: 'text',
  },
  {
    bp: { xs: 12 },
    field: 'certificatesNumber', label: 'Номер удостоверения на право производства сварочных работ', type: 'text',
  },
  {
    bp: { xs: 12 },
    field: 'certificatesDate', label: 'Срок действия удостоверения на право производства сварочных работ', type: 'text', textProps: { type: 'date' }, labelProps: { shrink: true },
  },
  {
    bp: { xs: 12 },
    field: 'certificatesSeams', label: 'Допущен  к сварке (швов в пространственном положении)', type: 'text',
  },
  {
    bp: { xs: 12 },
    field: 'markTest', label: 'Отметка  о сварке пробных  и контрольных образцов', type: 'text',
  },
]
export default function WeldersAdd(props) {
  const history = useHistory()
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(actions.formInitialize({
      firstName: '',
      lastName: '',
      middleName: '',
      qualification: '',
      stamp: '',
      certificatesNumber: '',
      certificatesDate: null,
      certificatesSeams: '',
      markTest: '',
      errorValidate: { firstName: false, lastName: false, }
    }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch])
  const form = useSelector(state => state.form[formName] || state.form.default)
  const handleSave = (e) => {
    const { values } = form
    e.preventDefault();
    const isError = validateProps(arrProps, values)
    dispatch(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
    if (isError.check) {
      dispatch(enqueueSnackbar({
        message: `некорректные поля`,
        options: { variant: 'error' }
      }))
      return;
    }
    dispatch(actions.formSubmitAPI({
      props: {
        firstName: values.firstName,
        lastName: values.lastName,
        middleName: values.middleName,
        qualification: values.qualification,
        stamp: values.stamp,
        certificatesNumber: values.certificatesNumber,
        certificatesDate: values.certificatesDate,
        certificatesSeams: values.certificatesSeams,
        markTest: values.markTest,
      },
      url: addWeldersOne.path({ id: props.match.params.idProject }),
      method: addWeldersOne.type,
      history: history
    }, formName))
  }
  return <div className='App-paper'>
    <form autoComplete="off" onSubmit={handleSave}>
      <div style={{ padding: '16px' }}>
        <SimpleAdd
          formName={formName}
          arr={arrProps}
          title='Добавить персонал'
          gridProps={{ sm: 12, md: 6 }}
        />
      </div>
      <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
      <Button type="submit" color="primary">Сохранить</Button>
    </form>
  </div>
}